import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqItems } from "@/mocks/categories";

export default function FAQ() {
  const { t } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-10">
          {t("faq.title")}
        </h2>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIdx === idx ? "rotate-45" : ""}`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? "max-h-96" : "max-h-0"
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}